import { createContext } from 'react';

export const StrategySchemaV2Context = createContext(null);
